import { RuntimeConfig } from '../app/core/models';

export const environment: RuntimeConfig = {
  apiUrl: 'https://api.dev.probeplane.com',
  cognitoDomain: 'https://auth.dev.probeplane.com',
  cognitoClientId: '620vmopogjr4dapq0e02omjhvl',
};
